
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M14.4 6h-9l1.3-1.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3 3c-.4.4-.4 1 0 1.4l2.9 2.9.1.1c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L5.4 8h9.2c3.2.1 5.7 2.7 5.7 5.9s-2.5 5.8-5.7 5.9v2c4.3-.1 7.7-3.6 7.7-7.9 0-4.4-3.5-7.9-7.9-7.9zm-3.5 14.8c0 .6.4 1 1 1h2.7v-2h-2.7c-.6 0-1 .4-1 1zm5.694-7.203c-.002 1.917-.886 3.03-2.349 3.03-1.466-.002-2.355-1.118-2.35-3.03.003-1.907.89-2.995 2.35-2.995 1.457 0 2.352 1.091 2.35 2.995zm-3.446 0c-.002 1.34.43 2.01 1.097 2.01.665 0 1.097-.67 1.094-2.01 0-1.321-.432-1.986-1.094-1.986-.665 0-1.094.665-1.097 1.986zm-3.723-2.915h1.156V16.5h-1.23v-4.65h-.034l-1.333.835v-1.091l1.44-.912z"}})])
          )
        }
      }
    